export var fromNow = function (date) {
    var inputDate = new Date(date);
    var diffMs = Date.now() - inputDate.getTime();
    var seconds = Math.abs(Math.floor(diffMs / 1000));
    var minutes = Math.abs(Math.floor(seconds / 60));
    var hours = Math.abs(Math.floor(minutes / 60));
    var days = Math.abs(Math.floor(hours / 24));
    var months = Math.abs(Math.floor(days / 30.44));
    var years = Math.abs(Math.floor(days / 365.25));
    if (seconds < 45)
        return 'a few seconds ago';
    if (seconds < 90)
        return 'a minute ago';
    if (minutes < 45)
        return "".concat(minutes, " minutes ago");
    if (minutes < 90)
        return 'an hour ago';
    if (hours < 24)
        return "".concat(hours, " hours ago");
    if (hours < 36)
        return 'a day ago';
    if (days < 30)
        return "".concat(days, " days ago");
    if (days < 45)
        return 'a month ago';
    if (months < 12)
        return "".concat(Math.floor(months), " months ago");
    if (months < 18)
        return 'a year ago';
    return "".concat(Math.floor(years), " years ago");
};
export var convertUTCDateToLocalDate = function (timestamp) {
    if (timestamp === void 0) { timestamp = '2023-02-14T06:56:11.051000'; }
    /* 1. take the timestamp
     *  2. detect the system's timezone
     *  3. convert timestamp into the system's timezone
     */
    if (timestamp.includes('Z')) {
        //if time is in iso format
        var date = new Date(timestamp);
        return date;
    }
    else {
        //if time is not in iso format
        var date = new Date(timestamp);
        var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
        return newDate;
    }
};
export var formatDate = function (date) {
    var inputDate = new Date(date);
    var options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    };
    return inputDate.toLocaleDateString(undefined, options);
};
